export const AUXILIAR_COMPONENT_POSITION_TOP = 'top';
export const AUXILIAR_COMPONENT_POSITION_BOTTOM = 'bottom';
export const AUXILIAR_COMPONENT_POSITIONS = [
  AUXILIAR_COMPONENT_POSITION_TOP,
  AUXILIAR_COMPONENT_POSITION_BOTTOM
];
